import { render, staticRenderFns } from "./reviewer.vue?vue&type=template&id=206df12c&scoped=true&"
import script from "./reviewer.vue?vue&type=script&lang=js&"
export * from "./reviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206df12c",
  null
  
)

export default component.exports